export enum UserRole {
    Customer = 'customer',
    Designer = 'designer',
}

export type SSOLinkingCookieType = {
    provider_email: string;
    email: string;
    target: string;
    cancel_target: string;
    expires_at: string;
};

export type SSOLinkingDetails = {
    providerEmail: string;
    email: string;
    target: string;
    cancelTarget: string;
    expiresAt: Date;
    linkingUserStatus: () => SSOLinkingUserStatus;
    isExpired: () => boolean;
};

export type SSOLinkingUserStatus = 'confirmed' | 'unconfirmed';

export type SSONewUserCookieType = {
    source: string;
    target: string;
    cancel_target: string;
    expires_at: string;
    requires_marketing_opt_in: boolean;
    role?: UserRole;
};

export type SSONewUserDetails = {
    source: string;
    target: string;
    cancelTarget: string;
    expiresAt: Date;
    role?: UserRole;
    requires_marketing_opt_in: boolean;
    isExpired: () => boolean;
};
